import React, { useState, useEffect } from 'react';
import PhoneCodes from './partials/phone_codes';

import bunnyLogo from '~/images/bunnynet-light.svg';
import DemoData from '~/data/sidebar/demo_page.json';
import PostHogHelper from '../../utils/posthog-helper';
import { navigate } from 'gatsby';

const Demo = ({ block }) => {
  const [active, setActive] = useState(0);
  const countTestimonials = DemoData.testimonials.items.length;

  let animationInterval;

  const toggleTestimonials = e => {
    const index = parseInt(e.target.id, 0);
    if (index !== active) {
      setActive(index);
    }
  };

  const startAnimation = () => {
    animationInterval = setInterval(() => {
      setActive(active + 1 >= countTestimonials ? 0 : active + 1);
    }, 5000);
  };

  const pauseAnimation = () => {
    clearInterval(animationInterval);
  };

  useEffect(() => {
    startAnimation();
    return () => clearInterval(animationInterval);
  }, [active]);

  const [submitted, setSubmitted] = useState(false);
  const [success, setSuccess] = useState(false);

  const [selectedCountry, setSelectedCountry] = useState('US');

  const handlePhoneCode = phoneCode => {
    setSelectedCountry(phoneCode);
  };

  let contactUrl = 'https://api.bunny.net/contact/submit-form';
  let contactType = 1; // 0 = contact, 1 = sales, 2 = abuse
  let thankyouPageUrl = 'https://bunny.net/thank-you-demo';

  const handleSubmit = e => {
    e.preventDefault();

    const contactForm = document.getElementById('cf-wr');
    var formData = new FormData(contactForm);
    const contactEmail = `${formData.get('ContactEmail')}`;

    if (formData.get('FullName') === null) {
      formData.append(
        'FullName',
        formData.get('FirstName') + ' ' + formData.get('LastName')
      );
      formData.delete('FirstName');
      formData.delete('LastName');
    }

    let phoneData;
    if (formData.get('Phone')) {
      phoneData = formData.get('Phone');
      formData.delete('Phone');
      formData.append('Phone', '+' + selectedCountry + ' ' + phoneData);
    }

    let servicesCheckbox = document.getElementsByName('Services');
    let servicesData = [];

    servicesCheckbox.forEach(checkbox => {
      if (checkbox.checked) {
        servicesData.push(checkbox.value);
      }
    });
    formData.append('Services', servicesData);
    formData.append('Title', 'Demo Request');

    let formBody = {};
    for (var entry of formData.entries()) {
      formBody[entry[0]] = entry[1];
    }
    const stringifiedFormBody = JSON.stringify(formBody);

    fetch(contactUrl, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: stringifiedFormBody,
    }).then(async response => {
      setSubmitted(true);

      if (response.ok) {
        setSuccess(true);
        await PostHogHelper.promiseToCaptureEmail(contactEmail);
        navigate(thankyouPageUrl);
      } else {
        setSuccess(false);
      }
    });
  };

  return (
    <section
      className={`block ${block._template} ${block.css_class_name} contact-form contact-form--compact`}
    >
      <div className='left'>
        <div className='container'>
          <a
            className='logo'
            href='/'
          >
            <img
              src={bunnyLogo}
              alt='bunny.net'
              title='bunny.net'
            />
          </a>

          <div className='testimonials-wrapper'>
            <div
              className='testimonials-wr'
              onMouseEnter={pauseAnimation}
              onMouseLeave={startAnimation}
            >
              {DemoData.testimonials.items.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`testimonial ${active === index ? 'is-active' : ''}`}
                    active={`${active === index}`}
                  >
                    {item.logo && (
                      <img
                        className='img-logo'
                        src={item.logo}
                        alt={item.name}
                        title={item.name}
                      />
                    )}
                    <div
                      className='quote'
                      dangerouslySetInnerHTML={{ __html: item.quote }}
                    ></div>
                    <div className='name'>{item.name}</div>
                    <div className='company'>{item.company}</div>
                  </div>
                );
              })}
            </div>

            <ul className='testimonials-list'>
              {DemoData.testimonials.items.map((item, index) => {
                return (
                  <li
                    key={index}
                    className={`${active === index ? 'is-active' : ''}`}
                    onClick={toggleTestimonials}
                    active={`${active === index}`}
                    id={`${index}`}
                  ></li>
                );
              })}
            </ul>
          </div>

          <div className='logos-wr'>
            <div className='title'>
              We've helped amazing companies hop faster!
            </div>
            <ul className='logos'>
              {DemoData.testimonials.logos.map((logo, index) => {
                return (
                  <li
                    key={index}
                    className={``}
                  >
                    <img
                      src={logo.image}
                      alt={logo.name}
                      title={logo.name}
                    />
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>

      <div className='right'>
        <div className='container'>
          <div className='row'>
            <div className='col-12'>
              <h1>{DemoData.form.title}</h1>
              {DemoData.form.text && (
                <div
                  className='text-formatted'
                  dangerouslySetInnerHTML={{ __html: DemoData.form.text }}
                ></div>
              )}
            </div>
          </div>
          <div className='form-wr'>
            <form
              onSubmit={handleSubmit}
              id='cf-wr'
            >
              <div className='row'>
                <div className='col-md-6'>
                  <div className='form-item'>
                    <label htmlFor='FirstName'>First Name</label>
                    <input
                      type='text'
                      name='FirstName'
                      id='FirstName'
                      required
                      placeholder='Your first name'
                    />
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='form-item'>
                    <label htmlFor='LastName'>Last Name</label>
                    <input
                      type='text'
                      name='LastName'
                      id='LastName'
                      required
                      placeholder='Your last name'
                    />
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='form-item'>
                    <label htmlFor='ContactEmail'>Email</label>
                    <input
                      type='email'
                      name='ContactEmail'
                      id='ContactEmail'
                      required
                      placeholder='you@company.com'
                    />
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='form-item'>
                    <label htmlFor='CompanyName'>Company Name</label>
                    <input
                      type='text'
                      name='CompanyName'
                      id='CompanyName'
                      placeholder='Your company name'
                    />
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='form-item'>
                    <label htmlFor='Phone'>Phone number</label>
                    <div className='phone-wr'>
                      <PhoneCodes setPhoneCode={handlePhoneCode} />
                      <input
                        type='text'
                        name='Phone'
                        id='Phone'
                        placeholder='xxx-xxx-xxxx'
                      />
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='form-item form-select'>
                    <label htmlFor='EstimatedTraffic'>
                      Estimated monthly traffic
                    </label>
                    <select
                      name='EstimatedTraffic'
                      id='EstimatedTraffic'
                    >
                      <option value="I don't know">I don't know</option>
                      <option value='Less than 100TB'>Less than 100TB</option>
                      <option value='100TB - 500TB'>100TB - 500TB</option>
                      <option value='500TB - 1000TB'>500TB - 1000TB</option>
                      <option value='1PB - 10PB'>1PB - 10PB</option>
                      <option value='10PB - 50PB'>10PB - 50PB</option>
                      <option value='More than 50PB'>More than 50PB</option>
                    </select>
                  </div>
                </div>
                <div className='col-12'>
                  <div className='form-item'>
                    <label htmlFor='Message'>Message</label>
                    <textarea
                      name='Message'
                      id='Message'
                      required
                      minLength='10'
                      placeholder='Tell us about your project and how bunny.net can help you.'
                    ></textarea>
                  </div>
                </div>
                <div className='col-12'>
                  <div className='form-item services'>
                    <fieldset className='checkbox-row'>
                      <div className='checkbox-item'>
                        <input
                          type='checkbox'
                          id='contentDelivery'
                          name='Services'
                          value='Content Delivery'
                        />
                        <label
                          className='checkbox-label'
                          htmlFor='contentDelivery'
                        >
                          Content Delivery
                        </label>
                      </div>

                      <div className='checkbox-item'>
                        <input
                          type='checkbox'
                          id='videoDelivery'
                          name='Services'
                          value='Video Delivery'
                        />
                        <label
                          className='checkbox-label'
                          htmlFor='videoDelivery'
                        >
                          Video Delivery
                        </label>
                      </div>

                      <div className='checkbox-item'>
                        <input
                          type='checkbox'
                          id='liveStreaming'
                          name='Services'
                          value='Live Streaming'
                        />
                        <label
                          className='checkbox-label'
                          htmlFor='liveStreaming'
                        >
                          Live Streaming
                        </label>
                      </div>

                      <div className='checkbox-item'>
                        <input
                          type='checkbox'
                          id='onlineStorage'
                          name='Services'
                          value='Online Storage'
                        />
                        <label
                          className='checkbox-label'
                          htmlFor='onlineStorage'
                        >
                          Online Storage
                        </label>
                      </div>

                      <div className='checkbox-item'>
                        <input
                          type='checkbox'
                          id='softwareDistribution'
                          name='Services'
                          value='Software Distribution'
                        />
                        <label
                          className='checkbox-label'
                          htmlFor='softwareDistribution'
                        >
                          Software Distribution
                        </label>
                      </div>

                      <div className='checkbox-item'>
                        <input
                          type='checkbox'
                          id='ddosProtection'
                          name='Services'
                          value='DDoS Protection'
                        />
                        <label
                          className='checkbox-label'
                          htmlFor='ddosProtection'
                        >
                          DDoS Protection
                        </label>
                      </div>
                    </fieldset>
                  </div>
                </div>
                <div className='col-12 form-submit'>
                  <input
                    type='hidden'
                    id='IsValid'
                    name='IsValid'
                    value='false'
                  />
                  <input
                    type='hidden'
                    id='Type'
                    name='Type'
                    value={contactType}
                  />
                  <div className='form-terms'>
                    <input
                      type='checkbox'
                      id='AgreeWithTerms'
                      name='AgreeWithTerms'
                      required
                      value='I have read and agree to the bunny.net Privacy Policy.'
                    />
                    <label htmlFor='AgreeWithTerms'>
                      I have read and agree to the bunny.net Privacy Policy.
                    </label>
                  </div>

                  <button
                    type='submit'
                    name='submit'
                    className='form-action'
                    value='Submit Demo Request'
                  >
                    Submit Demo Request
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Demo;
